export default __webpack_public_path__ + "static/media/7.96c1376f.png";